/* unplugin-vue-components disabled */import { render } from "./CurrentSelect.vue?vue&type=template&id=13b644b2&scoped=true&ts=true"
import script from "./CurrentSelect.vue?vue&type=script&lang=ts"
export * from "./CurrentSelect.vue?vue&type=script&lang=ts"

import "./CurrentSelect.vue?vue&type=style&index=0&id=13b644b2&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b644b2"]])

export default __exports__